import React, { useState } from "react";
import { withStyles, IconButton } from "@material-ui/core";
import styles from "../styles";
import Button from "../../../../components/ui/Buttons/Button";
import FilterIcon from "../../../../components/Icon/FilterIcon";
import { InputForm } from "../../../../components/Modal/Input";
import ItemGrid from "../../../../components/Modal/ItemGrid";
import SearchIcon from "../../../../components/Icon/Search";
import { ReactSelect } from "../../../../components/Select/SelectSearch";

const Filter = ({
  classes,
  onClickFilterButton,
  onChange,
  filter,
  handleApplyFilter,
  isLoading,
  secondaryButton,
  tertiaryButton,
  label,
  screen,
  showSelect,
  labelSelect,
  optionsSelect,
  onChangeSelect,
  valueSelect,
  placeholder
}) => {

  const [inputValue,setInputValue]=useState("")

  const handleKeyPress = () => {
    handleApplyFilter();
  };

  const onChangeInterno = (e)=>{
    setInputValue(e?.target?.value)
  }

  const handleApplyFilterInterno = ()=>{
    handleApplyFilter(inputValue)
  }

  return (
    <div className={classes.filterContainer}>
      <div style={{ flex: 1 }}>
        <ItemGrid
          label={label ?? "Pesquise por pacientes"}
          classes={{
            item: classes.item,
          }}
        >
          <InputForm
            id="pac-flt-inp-pes"
            placeholder={placeholder ?? "Pesquisar"}
            className={classes.inputTextField}
            onChange={
              screen !== "lotes"
                ? (e) => onChange(e.target.value, "search")
                : (e) => onChangeInterno(e)
            }
            onKeyDown={(e) => e.key === "Enter" && handleKeyPress()}
            value={screen !== "lotes" ? filter.search : inputValue}
            startAdornment={
              <IconButton
                id="pac-flt-btn-pes"
                className={classes.searchButton}
                onClick={
                  screen !== "lotes"
                    ? handleApplyFilter
                    : handleApplyFilterInterno
                }
                disabled={isLoading}
              >
                <SearchIcon />
              </IconButton>
            }
          />
        </ItemGrid>
      </div>
      <Button
        id="pac-flt-btn-fil"
        kind="secondary"
        startEnhancer={<FilterIcon size={12} color="white" />}
        onClick={onClickFilterButton}
        className={classes.filterButton}
      >
        Filtrar
      </Button>
      {secondaryButton && (
        <Button
          id="pac-flt-btn-sec"
          kind={"secondary"}
          onClick={() => secondaryButton.onClick()}
          className={classes.filterButton}
          startEnhancer={secondaryButton.icon}
          bgColor={"#219A97"}
        >
          {secondaryButton.label}
        </Button>
      )}
      {tertiaryButton && (
        <Button
          id="pac-flt-btn-ter"
          kind={"secondary"}
          onClick={() => tertiaryButton.onClick()}
          className={classes.filterButton}
          startEnhancer={tertiaryButton.icon}
          bgColor={"#219A97"}
        >
          {tertiaryButton.label}
        </Button>
      )}
      {showSelect && (
        <div className={classes.select}>
          <label className={classes.label}>{labelSelect}</label>
          <ReactSelect
            id="pac-flt-sel-opt"
            options={optionsSelect}
            onChange={onChangeSelect}
            value={valueSelect}
          />
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(Filter);
